var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea-autosize',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"modal-textarea-subtitle",style:({color: _vm.card.textColor}),attrs:{"title":this.section.value.length + ' / ' + this.lengthLimit},model:{value:(_vm.section.value),callback:function ($$v) {_vm.$set(_vm.section, "value", $$v)},expression:"section.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }